import { render, staticRenderFns } from "./InfluencerCard.vue?vue&type=template&id=201b15fb&scoped=true&"
import script from "./InfluencerCard.ts?vue&type=script&lang=ts&"
export * from "./InfluencerCard.ts?vue&type=script&lang=ts&"
import style0 from "./InfluencerCard.scss?vue&type=style&index=0&id=201b15fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201b15fb",
  null
  
)

export default component.exports